export const PARAM_ENTITY_CODE = 'entityCode';
export const PARAM_CURRENCY_CODE = 'currencyCode';
export const PARAM_DOCUMENT_ENTRY_NUMBER = 'entryNumber';
export const PARAM_SHARE_CLASS = 'shareClass';
export const PARAM_SHARE_CLASS_LINE = 'shareClassLine';
export const PARAM_INVOICE_CODE = 'invoiceCode';
export const PARAM_CONVERSATION_ID = 'conversationId';
export const PARAM_CONVERSATION_MESSAGE_NUMBER = 'messageNumber';
export const PARAM_CONVERSATION_MESSAGE_ATTACHMENT_NUMBER = 'attachmentNumber';
export const PARAM_TASK_ID = 'taskId';
export const PARAM_TASK_STEP_ID = 'stepId';
export const PARAM_REQUEST_STATUS = 'requestStatus';
export const PARAM_REQUEST_TYPE_ID = 'requestTypeId';
export const PARAM_REQUEST_ID = 'requestId';
export const PARAM_REQUEST_STEP_ID = 'stepId';
export const PARAM_FILE_ID = 'fileId';
export const PARAM_FILE_NAME = 'filename';
export const PARAM_ENTITY_ACCOUNT_ID = 'entityAccountId';
export const PARAM_ENTITY_ASSET_ID = 'entityAssetId';
export const PARAM_ENTITY_ASSET_PORTFOLIO_NUMBER = 'entityAssetPortfolioNumber';
export const PARAM_ENTITY_INVESTMENT_ID = 'entityInvestmentId';
export const PARAM_ENTITY_INVESTMENT_PORTFOLIO_NUMBER = 'entityInvestmentPortfolioNumber';
export const PARAM_ENTITY_LOAN_ID = 'entityLoanId';
export const PARAM_USER_ID = 'userId';

export const BFF_CONFIG_SCRIPT = '/boot.js';

export const FILE_DOWNLOAD = 'files/:' + PARAM_FILE_ID + '/:' + PARAM_FILE_NAME;

export const API_USER_SESSION_LOAD = 'api/status';
export const API_USER_SESSION_EXTEND = 'api/user/session';
export const API_USER_LOGIN = 'api/user/login';
export const API_USER_PASSWORD_RESET_REQUEST = '/api/user/password-reset-request';
export const API_USER_LOGOUT = 'api/user/logout';
export const API_USER_MFA_SETUP = 'api/user/mfa/setup';
export const API_USER_MFA_VERIFY = 'api/user/mfa/verify';
export const API_USER_PASSWORD_RESET = 'api/user/reset-password';
export const API_USER_PASSWORD_CHANGE = 'api/user/change-password';
export const API_USER_TERMS = 'api/user/terms';
export const API_USER_ACCESSIBILITY = 'api/user/accessibility';
export const API_USERS = 'api/users';
export const API_USER_PERMISSIONS = 'api/users/:' + PARAM_USER_ID + '/permissions';
export const API_USER_DELETE = 'api/users/:' + PARAM_USER_ID;
export const API_USER_INVITE = 'api/users/:' + PARAM_USER_ID + '/invite';

export const API_ENTITIES = 'api/entities';
export const API_ENTITY = API_ENTITIES + '/:' + PARAM_ENTITY_CODE;
export const API_ENTITY_RELATED_PARTIES = API_ENTITY + '/related-parties';
export const API_ENTITY_INVOICES = API_ENTITY + '/invoices';
export const API_ENTITY_INVOICE_DETAILS = API_ENTITY_INVOICES + '/details';
export const API_ENTITY_INVOICE_DETAILS_CURRENCY = API_ENTITY_INVOICE_DETAILS + '/currencies/:' + PARAM_CURRENCY_CODE;
export const API_ENTITY_DOCUMENTS = API_ENTITY + '/documents';
export const API_ENTITY_DOCUMENT_DOWNLOAD = API_ENTITY_DOCUMENTS + '/:' + PARAM_DOCUMENT_ENTRY_NUMBER + '/download';
export const API_ENTITY_SHARE_CLASSES = API_ENTITY + '/share-classes';
export const API_ENTITY_SHARE_CLASS_SHAREHOLDERS = API_ENTITY_SHARE_CLASSES + '/:' + PARAM_SHARE_CLASS + '/lines/:' + PARAM_SHARE_CLASS_LINE + '/currencies/:' + PARAM_CURRENCY_CODE;
export const API_ENTITY_ACCOUNTS = API_ENTITY + '/accounts';
export const API_ENTITY_ACCOUNT_TRANSACTIONS = API_ENTITY_ACCOUNTS + '/:' + PARAM_ENTITY_ACCOUNT_ID + '/transactions';
export const API_ENTITY_ASSETS = API_ENTITY + '/assets';
export const API_ENTITY_ASSET_TRANSACTIONS = API_ENTITY_ASSETS + '/:' + PARAM_ENTITY_ASSET_ID + '/transactions';
export const API_ENTITY_INVESTMENTS = API_ENTITY + '/investments';
export const API_ENTITY_INVESTMENT_TRANSACTIONS = API_ENTITY_INVESTMENTS + '/:' + PARAM_ENTITY_INVESTMENT_ID + '/portfolio/:' + PARAM_ENTITY_INVESTMENT_PORTFOLIO_NUMBER + '/transactions';
export const API_ENTITY_LOANS = API_ENTITY + '/loans';
export const API_ENTITY_LOAN_TRANSACTIONS = API_ENTITY_LOANS + '/:' + PARAM_ENTITY_LOAN_ID + '/transactions';
export const API_INVOICES = 'api/invoices';
export const API_INVOICE_LINES = 'api/invoices/:' + PARAM_INVOICE_CODE + '/lines';

// Conversation API endpoints
export const API_CONVERSATIONS = 'api/conversations/list';
export const API_CONVERSATION = 'api/conversations/:' + PARAM_CONVERSATION_ID;
export const API_CONVERSATION_DETAILS = API_CONVERSATION + '/details';
export const API_CONVERSATION_REPLY = API_CONVERSATION + '/reply';
export const API_CONVERSATION_REPLY_NO_ID = 'api/conversations/reply';
export const API_CONVERSATION_MESSAGE_ATTACHMENT_DOWNLOAD = API_CONVERSATION + '/messages/:' + PARAM_CONVERSATION_MESSAGE_NUMBER + '/attachments/:' + PARAM_CONVERSATION_MESSAGE_ATTACHMENT_NUMBER + '/download';
export const API_CONVERSATION_MESSAGE_ATTACHMENT_UPLOAD = API_CONVERSATION + '/messages/:' + PARAM_CONVERSATION_MESSAGE_NUMBER + '/attachments/:' + PARAM_CONVERSATION_MESSAGE_ATTACHMENT_NUMBER + '/upload';
export const API_CONVERSATION_MESSAGE_ATTACHMENT_DELETE = API_CONVERSATION + '/messages/:' + PARAM_CONVERSATION_MESSAGE_NUMBER + '/attachments/:' + PARAM_CONVERSATION_MESSAGE_ATTACHMENT_NUMBER + '/delete';

export const API_DOCUMENTS = 'api/documents';

export const API_TASKS = 'api/tasks';
export const API_TASK = API_TASKS + '/:' + PARAM_TASK_ID;
export const API_TASK_STEP = API_TASK + '/steps/:' + PARAM_TASK_STEP_ID;
export const API_TASK_STEP_GBG = API_TASK_STEP + '/gbg';
export const API_TASK_STEP_SUBMIT = API_TASK_STEP + '/submit';
export const API_TASK_STEP_UPLOAD_SAS = API_TASK_STEP + '/attachment/upload';
export const API_TASK_STEP_DELETE_SAS = API_TASK_STEP + '/attachment/delete';
export const API_TASK_STEP_DOWNLOAD_SAS = API_TASK_STEP + '/attachment/download';

export const API_REQUEST_TYPES = 'api/request-types';
export const API_REQUESTS = 'api/requests';
export const API_REQUESTS_BY_STATUS = API_REQUESTS + '/:' + PARAM_REQUEST_STATUS;
export const API_INITIATE_REQUEST = API_REQUESTS + '/initiate/:' + PARAM_REQUEST_TYPE_ID;
export const API_CANCEL_REQUEST = API_REQUESTS + '/cancel/:' + PARAM_REQUEST_ID;
export const API_REQUEST = API_REQUESTS + '/request/:' + PARAM_REQUEST_ID;
export const API_REQUEST_STEP = API_REQUEST + '/steps/:' + PARAM_REQUEST_STEP_ID;
export const API_REQUEST_STEP_GBG = API_REQUEST_STEP + '/gbg';
export const API_REQUEST_STEP_SUBMIT = API_REQUEST_STEP + '/submit';
export const API_REQUEST_STEP_UPLOAD_SAS = API_REQUEST_STEP + '/attachment/upload';
export const API_REQUEST_STEP_DELETE_SAS = API_REQUEST_STEP + '/attachment/delete';
export const API_REQUEST_STEP_DOWNLOAD_SAS = API_REQUEST_STEP + '/attachment/download';

export const API_GBG_CONFIG = 'api/gbg/config';

export const API_NOTIFICATIONS_GROUPED = 'api/notifications/grouped';
export const API_NOTIFICATIONS_MARK_BY_TYPE = 'api/notifications/mark-by-type';

export const SAML_CALLBACK = '/saml/callback';
export const SAML_LOGOUT_CALLBACK = '/saml/logout/callback';
